import * as React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./IconSuccess.scss");
// tslint:disable-next-line:no-var-requires

const InformationOkIcon = () => {
    return <div className={style.iconSuccess} />;
};

export default InformationOkIcon;
